import $ from 'jquery';
import 'slick-carousel';

$('.cascade-nav').on('click', function() {
  const group = $(this).data('cascade-group');
  const last = $(`.cascade-group-${group}`).length;
  let next = $(this).attr('data-next');
  $('.cascade-pane').removeClass('latest');
  if (next <= last) {
    const $pane = $(`#cascade-${next}.cascade-group-${group}`);
    $pane.addClass('is-active');
    $pane.addClass('latest');

    if ( next == last ) {
      $(this).addClass('completed');
      $(this).closest('.cascade-group').addClass('completed');
    }
    $(this).attr('data-next', ++next);
  } 
});